import { isEmpty } from "../../utils/matchers/matchers.js";
import { objectKeysToSnakeCase } from "../../utils/object-keys-conversion.js";
//#region src/infrastructure/http-api/axios-api-request-interceptor.ts
var requestToSnakeCase = (request) => {
	const updatedRequest = { ...request };
	if (!isEmpty(request.params)) updatedRequest.params = objectKeysToSnakeCase(request.params);
	if (!isEmpty(request.data)) updatedRequest.data = objectKeysToSnakeCase(request.data);
	return updatedRequest;
};
//#endregion
export { requestToSnakeCase };

//# sourceMappingURL=axios-api-request-interceptor.js.map